import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { toNum } from '@shared/helpers/math.helper';
import { checkRequiredFieldWithTipoBilancio, getDatiBilancioGroup } from './helpers/dati-bilancio-bis-form-validators.helper';

export const datiBilancioBisStatoPatrimonialeAttivoRules: FormGroupRules = {
    my_StPaAtCII1a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII1a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII2a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII2a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII3a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII3a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII4a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII4a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII5a1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII5a1', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCIIa1: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCIIa1', 'my_TipoBilancioAbbr1', '1');
    },
    my_StPaAtCII1a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII1a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII2a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII2a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII3a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII3a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII4a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII4a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCII5a2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCII5a2', 'my_TipoBilancioAbbr1', '0');
    },
    my_StPaAtCIIa2: (form: FormGroup) => {
        checkRequiredFieldWithTipoBilancio(form, 'my_StatoPatrimoniale__Attivo.my_StPaAtCIIa2', 'my_TipoBilancioAbbr1', '1');
    },
    my_StPaAtTOT1: (form: FormGroup) => {
        const datiBilancioGroup = getDatiBilancioGroup(form);
        const my_StPaAtTOT1Control = getControl(datiBilancioGroup, 'my_StatoPatrimoniale__Attivo.my_StPaAtTOT1');
        const my_StPaAtTOT1 = toNum(my_StPaAtTOT1Control?.value);
        const my_TipoSchemaBil1: string = getControl(datiBilancioGroup, 'my_TipoSchemaBil1')?.value;
        const my_DataApprovazione1: string = getControl(datiBilancioGroup, 'my_DataApprovazione1')?.value;
        const errors = my_StPaAtTOT1Control.errors ? my_StPaAtTOT1Control.errors : {};

        addRemoveError(
            my_StPaAtTOT1 === 0 && !isNilOrEmpty(my_TipoSchemaBil1) && !isNilOrEmpty(my_DataApprovazione1),
            errors,
            'my_StPaAtTOT1',
            {
                status: 'Il totale dello Stato Patrimoniale Attivo del primo bilancio è nullo',
            }
        );

        my_StPaAtTOT1Control.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
